// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const sponsorsName = 'sponsors';
const sponsorName = 'sponsor';

// Action Types: Get All Tools.
export const GET_SPONSORS_START = 'GET_SPONSORS_START';
export const GET_SPONSORS_SUCCESS = 'GET_SPONSORS_SUCCESS';
export const GET_SPONSORS_FAILED = 'GET_SPONSORS_FAILED';
export const GET_SPONSORS_RESET = 'GET_SPONSORS_RESET';

// Action Types: Get One SPONSOR.
export const GET_SPONSOR_START = 'GET_SPONSOR_START';
export const GET_SPONSOR_SUCCESS = 'GET_SPONSOR_SUCCESS';
export const GET_SPONSOR_FAILED = 'GET_SPONSOR_FAILED';
export const GET_SPONSOR_RESET = 'GET_SPONSOR_RESET';

// Action Types: Create SPONSOR.
export const CREATE_SPONSOR_START = 'CREATE_SPONSOR_START';
export const CREATE_SPONSOR_SUCCESS = 'CREATE_SPONSOR_SUCCESS';
export const CREATE_SPONSOR_FAILED = 'CREATE_SPONSOR_FAILED';
export const CREATE_SPONSOR_RESET = 'CREATE_SPONSOR_RESET';

// Action Types: Update SPONSOR.
export const UPDATE_SPONSOR_START = 'UPDATE_SPONSOR_START';
export const UPDATE_SPONSOR_SUCCESS = 'UPDATE_SPONSOR_SUCCESS';
export const UPDATE_SPONSOR_FAILED = 'UPDATE_SPONSOR_FAILED';
export const UPDATE_SPONSOR_RESET = 'UPDATE_SPONSOR_RESET';

// Action Types: Delete SPONSOR.
export const DELETE_SPONSOR_START = 'DELETE_SPONSOR_START';
export const DELETE_SPONSOR_SUCCESS = 'DELETE_SPONSOR_SUCCESS';
export const DELETE_SPONSOR_FAILED = 'DELETE_SPONSOR_FAILED';
export const DELETE_SPONSOR_RESET = 'DELETE_SPONSOR_RESET';

// Action Creators: Get All Sponsors.
const getSponsorsStart = (payload) => ({ type: GET_SPONSORS_START, payload });
const getSponsorsSuccess = (payload) => ({ type: GET_SPONSORS_SUCCESS, payload });
const getSponsorsFailed = (payload) => ({ type: GET_SPONSORS_FAILED, payload });
const getSponsorsReset = () => ({ type: GET_SPONSORS_RESET });

// Action Creators: Get One Sponsor.
const getSponsorStart = (payload) => ({ type: GET_SPONSOR_START, payload });
const getSponsorSuccess = (payload) => ({ type: GET_SPONSOR_SUCCESS, payload });
const getSponsorFailed = (payload) => ({ type: GET_SPONSOR_FAILED, payload });
const getSponsorReset = () => ({ type: GET_SPONSOR_RESET });

// Action Creators: Create SPONSOR.
const createSponsorStart = (payload) => ({ type: CREATE_SPONSOR_START, payload });
const createSponsorSuccess = (payload) => ({ type: CREATE_SPONSOR_SUCCESS, payload });
const createSponsorFailed = (payload) => ({ type: CREATE_SPONSOR_FAILED, payload });
const createSponsorReset = () => ({ type: CREATE_SPONSOR_RESET });

// Action Creators: Update SPONSOR.
const updateSponsorStart = (payload) => ({ type: UPDATE_SPONSOR_START, payload });
const updateSponsorSuccess = (payload) => ({ type: UPDATE_SPONSOR_SUCCESS, payload });
const updateSponsorFailed = (payload) => ({ type: UPDATE_SPONSOR_FAILED, payload });
const updateSponsorReset = () => ({ type: UPDATE_SPONSOR_RESET });

// Action Creators: Delete SPONSOR.
const deleteSponsorStart = (payload) => ({ type: DELETE_SPONSOR_START, payload });
const deleteSponsorSuccess = (payload) => ({ type: DELETE_SPONSOR_SUCCESS, payload });
const deleteSponsorFailed = (payload) => ({ type: DELETE_SPONSOR_FAILED, payload });
const deleteSponsorReset = () => ({ type: DELETE_SPONSOR_RESET });

// Actions: Get All Sponsors.
export const getSponsors = (payload, options = {}) => {
  const { page, limit, pagination, name } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getSponsorsStart);

      const query = { page, limit, pagination, name };
      const result = await ApiClient.get('/sponsors', { params: query });
      if (result.data?.success) {
        const { sponsors } = result.data?.data;
        dispatchSuccess(dispatch, getSponsorsSuccess, sponsors, sponsorsName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getSponsorsFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getSponsorsFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Sponsors.
export const clearSponsors = () => getSponsorsReset();

// Actions: Get One Sponsor.
export const getSponsor = (payload, options = {}) => {
  const { sponsorId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getSponsorStart);

      const result = await ApiClient.get(`/sponsors/${sponsorId}`);
      if (result.data?.success) {
        const { sponsor } = result.data?.data;
        dispatchSuccess(dispatch, getSponsorSuccess, sponsor, sponsorName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getSponsorFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getSponsorFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get One Sponsor.
export const clearSponsor = () => getSponsorReset();

// Actions: Create Sponsor.
export const createSponsor = (payload, options = {}) => {
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, createSponsorStart);

      // const { name, sponsorLink } = payload;

      const fields = ['name', 'description', 'sponsorLink', 'photo'];
      const formData = new FormData();
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.post(`/sponsors`, formData);
      if (result.data?.success) {
        const { sponsor } = result.data?.data;
        dispatchSuccess(dispatch, createSponsorSuccess, sponsor, sponsorName);
        showSnackbar(dispatch, 'Sponsor created successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, createSponsorFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, createSponsorFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Created Sponsor.
export const clearCreatedSponsor = () => createSponsorReset();

// Actions: Update Sponsor.
export const updateSponsor = (payload, options = {}) => {
  const { sponsorId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, updateSponsorStart);

      const fields = ['name', 'description', 'sponsorLink', 'photo'];
      const formData = new FormData();
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.put(`/sponsors/${sponsorId}`, formData);
      if (result.data?.success) {
        const { sponsor } = result.data?.data;
        dispatchSuccess(dispatch, updateSponsorSuccess, sponsor, sponsorName);
        showSnackbar(dispatch, 'Sponsor updated successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, updateSponsorFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, updateSponsorFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Updated Sponsor.
export const clearUpdatedSponsor = () => updateSponsorReset();

// Actions: Delete Sponsor.
export const deleteSponsor = (payload, options = {}) => {
  const { sponsorId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, deleteSponsorStart);

      const result = await ApiClient.delete(`/sponsors/${sponsorId}`);
      if (result.data?.success) {
        const { sponsor } = result.data?.data;
        dispatchSuccess(dispatch, deleteSponsorSuccess, sponsor, sponsorName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, deleteSponsorFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, deleteSponsorFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Deleted Sponsor.
export const clearDeletedSponsor = () => deleteSponsorReset();
